import type { MailboxEnvelope } from '@vivport/backend/types';

export interface MailboxEnvelopeRowData {
  providerMessageId: string;
  subject: string | null;
  fromName: string | null;
  fromEmail: string | null;
  receivedAt: string | null;
  snippet: string | null;
  hasAttachments: boolean;
  attachmentCount: number;
  folders: string[];
  webLink: string | null;
}

export function mailboxEnvelopeRowData(envelope: MailboxEnvelope): MailboxEnvelopeRowData {
  return {
    providerMessageId: envelope.providerMessageId,
    subject: envelope.subject,
    fromName: envelope.from.name,
    fromEmail: envelope.from.email,
    receivedAt: envelope.receivedAt ?? envelope.sentAt,
    snippet: envelope.snippet,
    hasAttachments: envelope.hasAttachments,
    attachmentCount: envelope.attachments.length,
    folders: envelope.folders,
    webLink: envelope.webLink,
  };
}
